export class UpaUserProfileDataModel {
  email: string
  userProfilePicUrl: string
  userAccountID: number
  access: string
  firstName: string
  middleName: string
  lastName: string
  dateOfBirth: string
  dni: string
  mobileNumber: number
  userGenderID: number
  province: number
  cityName: string
  civilStatus: string
  originCountry: string
  fullName:  string
}
